import { lazy } from "react";
// Provider Documentation Coach Module (Módulo F — BillingV2)
// Feedback educativo por provider: specificity, MEAT y HCC no documentados.

const ProviderDocCoachPage = lazy(() => import("./pages/ProviderDocCoachPage"));
// Export routes for AppRouter
export const providerDocCoachRoutes = [
  {
    path: "/provider-doc-coach",
    element: <ProviderDocCoachPage />,
  },
];

// Export components for external use

// Export utilities
export * from "./common/constants";
